import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

// OBTENER AUTORIZACIONES
export const getAutorizaciones = async () => {
  const respuesta = await PrivateInterceptor(`Compras/Autorizaciones`, "GET");
  return respuesta;
};


// OBTENER AUTORIZACIONES DE REQUISAS DE MATERIALES
export const getAutorizacionesRM = async () => {
  const respuesta = await PrivateInterceptor(`Compras/Autorizaciones/RMateriales`, "GET");
  return respuesta;
};


// FIRMAS DE FINANZAS Y GERENTE PLANTA
export const ChangeAuth = (data) => {
    const respuesta = PrivateInterceptor("Compras/Autorizaciones/ChangeAuth", "POST", {Detalle: data});
    return respuesta;
  };


// FIRMAS DE BODEGA Y PENDINTE DE REVISION
export const ChangeAuth1 = (data) => {
  const respuesta = PrivateInterceptor("Compras/Autorizaciones/ChangeAuth1", "POST", {Detalle: data});
  return respuesta;
};

// FIRMAS DE BODEGA Y PENDINTE DE REVISION
export const ChangeAuthRequisaMaterial = (data) => {
  const respuesta = PrivateInterceptor("Compras/Autorizaciones/ChangeAuthRM", "POST", {Detalle: data});
  return respuesta;
};
